import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Include helper methods for API calls
import {
  getSettlementPrices as getSettlementPricesApi,
  getSettlementPriceById as getSettlementPriceByIdApi,
  addNewSettlementPrice as addNewSettlementPriceApi,
  updateSettlementPrice as updateSettlementPriceApi,
  deleteSettlementPrice as deleteSettlementPriceApi,
} from "../../helpers/fakebackend_helper";

// Fetch Settlement Prices
export const getSettlementPrices = createAsyncThunk("settlementPrices", async (queryParams) => {
  try {
    const response = await getSettlementPricesApi(queryParams);
    return response;
  } catch (error) {
    toast.error("Failed to fetch settlement prices", { autoClose: 3000 });
    throw error;
  }
});
// Fetch a Single Settlement Price by ID
export const getSettlementPriceById = createAsyncThunk(
  "settlementPrices/getSettlementPriceById",
  async (id) => {
    try {
      const response = await getSettlementPriceByIdApi(id);
    } catch (error) {
      toast.error("Failed to fetch settlement price by ID", { autoClose: 3000 });
      throw error;
    }
  }
);

// Add New Settlement Price
export const addNewSettlementPrice = createAsyncThunk(
  "settlementPrices/addNewSettlementPrice",
  async (settlementPrice) => {
    try {
      const response = await addNewSettlementPriceApi(settlementPrice);
      toast.success("Settlement Price Added Successfully", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Failed to add settelement price", { autoClose: 3000 });
      throw error;
    }
  }
);

// Update Settlement Price
export const updateSettlementPrice = createAsyncThunk(
  "settlementPrices/updateSettlementPrice",
  async (settlementPrice) => {
    try {
      const response = await updateSettlementPriceApi(settlementPrice);
      toast.success("Settlement Price Updated Successfully", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Failed to update settelement price", { autoClose: 3000 });
      throw error;
    }
  }
);

// Delete Settlement Price
export const deleteSettlementPrice = createAsyncThunk(
  "settlementPrices/deleteSettlementPrice",
  async (settlementPriceId) => {
    try {
      const response = await deleteSettlementPriceApi(settlementPriceId);
      toast.success("Settlement Price Deleted Successfully", { autoClose: 3000 });
      return { settlementPriceId, ...response };
    } catch (error) {
      toast.error("Failed to delete settelement price", { autoClose: 3000 });
      throw error;
    }
  }
);
